<div class="row">
    <div class="col-md-12 pl-4">
        <yt-fw-default-update-buttons #defaultUpdateButtons></yt-fw-default-update-buttons>
    </div>
</div>
<yt-osoba-update #baseUpdate></yt-osoba-update>
<div class="row">
  <div class="col-md-12">
    <div class="btn-group float-right">
      <button type="button" class="btn btn-outline-primary" (click)="Save()" [disabled]="saveDisabled"><span class="fa fa-fa fa-save"></span> Sačuvaj</button>
      <button type="button" class="btn btn-outline-primary" (click)="Reset()"><span class="fa fa-fa fa-undo"></span> Odustani</button>
    </div>
  </div>
</div>
